import Cookies from 'js-cookie';
import WashdayClientSingleton from './WashdayClientSingleton';
import { preserveSessionRequests } from './sessionSecurity';

export type SessionTokenDispatch = (action: {
  type: 'SET_SESSION_TOKEN';
  token: string;
}) => unknown;

export function acceptSessionToken(
  token: string | undefined,
  requestToken: string | undefined,
  dispatch: SessionTokenDispatch
) {
  if (!token || !requestToken || Cookies.get('token') !== requestToken || token === requestToken)
    return;
  preserveSessionRequests(requestToken, token);
  Cookies.set('token', token);
  WashdayClientSingleton.refresh({ preserveSession: true });
  dispatch({ type: 'SET_SESSION_TOKEN', token });
}
